import { Box, Typography } from "@mui/material";

const HeroServicesAd = ({ services = [] }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        zIndex: 10,
      }}
    >
      {services.map((service, index) => (
        <Typography
          sx={{
            color: index === 1 ? "primary.main" : "paper.main",
            fontWeight: index <= 1 ? 700 : 500,
          }}
        >
          {service}
        </Typography>
      ))}
      <Typography color={"paper.main"} sx={{ fontWeight: 300 }}>
        & <br />
        <Typography
          component="span"
          color={"paper.main"}
          sx={{ fontWeight: 500 }}
        >
          More!
        </Typography>
      </Typography>
    </Box>
  );
};

export default HeroServicesAd;
